// import CryptoJS from 'crypto-js'
import { hasKeysOf } from './utils'

// const encrypt = (string) => CryptoJS.AES.encrypt(string, process.env.VUE_APP_SECRET_KEY)

// const decrypt = (string) => CryptoJS.AES.decrypt(string, process.env.VUE_APP_SECRET_KEY)

const LOCAL_KEY = 'localData'

const getLocalData = () => {
  // const cipherText = localStorage.getItem(LOCAL_KEY)
  // if (!cipherText) return {}
  // const bytes = decrypt(cipherText)
  // const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  // return decryptedData
  const data = localStorage.getItem(LOCAL_KEY)
  if (!data) return {}
  return JSON.parse(data)
}

const storeLocalData = (newLocalData) => {
  // const cipher = encrypt(JSON.stringify(localData))
  // localStorage.setItem(LOCAL_KEY, cipher)
  const localData = getLocalData()
  localStorage.setItem(LOCAL_KEY, JSON.stringify({ ...localData, ...newLocalData }))
}


export default class LocalStore {
  constructor({ schema = null } = {}) {
    if (schema) {
      console.log(!hasKeysOf(this.localData, schema))
      if (!hasKeysOf(this.localData, schema)) {
        storeLocalData(schema)
      }
    }
  }

  get localData() {
    return getLocalData()
  }

  get(key, defaultValue = null) {
    const keys = key.split('.')
    let result = this.localData
    for (const k of keys) {
      if (!result[k] || !result) return defaultValue
      result = result[k]
    }
    return result
  }

  set(...args) {
    if (args.length === 2) {
      const [key, data] = args
      storeLocalData({
        ...this.localData,
        [key]: data,
      })
      return
    }
    const data = args[0]
    storeLocalData({
      ...this.localData,
      ...data,
    })
  }

  delete(string) {
    const keys = Object.keys(this.localData).filter(key => key !== string)
    const data = keys.reduce((prev, next) => {
      prev[next] = this.localData[next]
      return prev
    }, {})
    localStorage.setItem(LOCAL_KEY, JSON.stringify(data))
  }

  clear() {
    localStorage.clear()
  }
}
